import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useAxesStore } from '../../store/useAxesStore';
import { LayoutGrid, Crown, Sparkles, LogOut } from 'lucide-react';

const AxesHeader: React.FC = () => {
    const { profile, signOut } = useAuth();
    const { activeLayout, setActiveLayout } = useAxesStore();
    const credits = profile?.credits ?? 0;
    const isPro = profile?.role === 'pro' || profile?.role === 'superadmin';

    return (
        <header className="h-12 bg-black border-b border-zinc-800 flex items-center justify-between px-6 z-20 shrink-0 select-none">
            <div className="flex items-center gap-3">
                <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-indigo-500 shadow-[0_0_8px_rgba(99,102,241,0.6)]" />
                    <span className="text-zinc-100 font-bold tracking-[0.2em] uppercase text-xs">Dotting</span>
                </div>
                <div className="h-4 w-px bg-zinc-800" />
                <div className="flex items-center gap-1.5 text-zinc-500">
                    <LayoutGrid size={12} className="text-indigo-400" />
                    <span className="text-[10px] font-mono tracking-wide uppercase">Axes</span>
                    <span className="text-[10px] font-mono tracking-wide text-zinc-700">— Foundation Algorithms for Saudi Residence</span>
                </div>

                {/* Breadcrumb when in detail view */}
                {activeLayout && (
                    <>
                        <div className="h-4 w-px bg-zinc-800" />
                        <button
                            onClick={() => setActiveLayout(null)}
                            className="text-[10px] text-indigo-400 font-mono hover:text-indigo-300 transition-colors"
                        >
                            ← Back to Explorer
                        </button>
                        <div className="text-[10px] text-zinc-600 font-mono">{activeLayout.id}</div>
                    </>
                )}
            </div>

            <div className="flex items-center gap-6">
                {isPro && (
                    <div className="flex items-center gap-1.5 px-2 py-0.5 rounded border border-yellow-900/30 bg-yellow-900/10">
                        <Crown size={10} className="text-yellow-500" />
                        <span className="text-[10px] text-yellow-500 font-bold tracking-wider uppercase">Pro</span>
                    </div>
                )}

                <div
                    className="flex items-center gap-2 bg-zinc-900 rounded-full px-3 py-1 border border-zinc-800 group hover:border-zinc-700 transition-colors cursor-help"
                    title="Available Generation Credits"
                >
                    <Sparkles className="w-3 h-3 text-emerald-400" />
                    <span className="text-zinc-300 text-xs font-medium tabular-nums">
                        {credits} <span className="text-zinc-600 ml-1">Credits</span>
                    </span>
                </div>

                <div className="w-6 h-6 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center text-xs text-zinc-400 font-medium select-none">
                    {profile?.full_name?.[0] || 'U'}
                </div>

                <button
                    onClick={signOut}
                    className="p-1.5 rounded-md text-zinc-500 hover:text-red-400 hover:bg-red-950/30 transition-colors"
                    title="Sign Out"
                >
                    <LogOut size={14} />
                </button>
            </div>
        </header>
    );
};

export default AxesHeader;
